import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { ExpandedCategoryGamesPopup } from './ExpandedCategoryGamesPopup';

export const showExpandedCategoryPopupAction = ({ onClose } = {},
                                                cid,
                                                gameCodes,
                                                displayName,
                                                isRecommendedCategory,
                                                formatCategoryName,
                                                mostPlayedGame) => addPopupAction({
    id: 'expandedCategoryPopup',
    layer: LAYER.EXPANDED_CATEGORY_POPUP,
    component: ExpandedCategoryGamesPopup,
    onClose,
    cid,
    gameCodes,
    displayName,
    isRecommendedCategory,
    formatCategoryName,
    mostPlayedGame
});
